import script from "./RankingFansList.vue?vue&type=script&setup=true&lang=js"
export * from "./RankingFansList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__